// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mBa5j","fullView":"styles_fullView__4V4bz"};